import { FC } from 'react'

export const Loading: FC<{ testId?: string }> = ({ testId = 'Loading' }) => (
  <div data-testid={testId}>Loading ...</div>
)

export const Error: FC<{ testId?: string }> = ({ testId = 'Error' }) => (
  <div data-testid={testId}>Error ...</div>
)
